module.exports = __webpack_public_path__ + "static/aqua-black-bc326e4b4e54474354f3227fd2321084.svg";